import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './components/auth/Login';
import QueueMonitor from './components/queue/QueueMonitor';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  const { terminal } = useAuth();

  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={
            terminal ? <Navigate to="/queue" replace /> : <Login />
          } 
        />
        <Route 
          path="/queue" 
          element={
            <ProtectedRoute>
              <QueueMonitor />
            </ProtectedRoute>
          } 
        />
        <Route path="/" element={<Navigate to="/queue" replace />} />
        <Route path="*" element={<Navigate to="/queue" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
